import dayjs from "dayjs";

import InvoiceData = App.Data.InvoiceData;

export const fmtDueState = (r: InvoiceData, t: any) => {
    const dueStr = r.to_date;
    if (!dueStr) return { label: t("status.pending"), tone: "pending" as const };

    const today = dayjs().startOf("day");
    const due = dayjs(dueStr).startOf("day");

    if (!due.isValid()) {
        return { label: t("status.unknownDue"), tone: "pending" as const };
    }

    const diffDays = due.diff(today, "day");

    if (diffDays < 0) return { label: t("status.overdue"), tone: "overdue" as const };
    if (diffDays === 0) return { label: t("status.dueToday"), tone: "pending" as const };
    return {
        label: t("status.dueInDays", { count: diffDays }),
        tone: "pending" as const,
    };
};
